"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOsdEventHandler = useOsdEventHandler;

var _react = require("react");

function useOsdEventHandler(source, eventName, callback) {
  var active = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  (0, _react.useLayoutEffect)(function () {
    if (source && active) {
      source.addHandler(eventName, callback);
      return function () {
        return source.removeHandler(eventName, callback);
      };
    }

    return;
  }, [active, callback, eventName, source]);
}